import {TranslationFunction} from "../../../i18n/i18n";
import {CatalogFormatter} from "../../../common/catalog/CatalogFormatter";

export class SubmissionDeliveryStateTypeFormatter {
    static formatSubmissionDeliveryStateType(code: string | null | undefined, t: TranslationFunction): string {
        return CatalogFormatter.formatCatalogValueByCode(code, "submissionDeliveryStateType", t);
    }
}
